class QuoteCart {
  constructor() {
    this.storageKey = 'nema_quote_cart';
    this.events = {
      UPDATED: 'quote:updated'
    };
    this.init();
  }

  init() {
    this.updateCount();
    window.addEventListener(this.events.UPDATED, () => this.updateCount());
  }

  getItems() {
    return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
  }

  addItem(product) {
    const items = this.getItems();
    // Check if item already exists (by variant ID)
    // Convert both IDs to strings for consistent comparison
    const existingIndex = items.findIndex(item => String(item.variantId) === String(product.variantId));

    if (existingIndex > -1) {
      items[existingIndex].quantity += parseInt(product.quantity);
    } else {
      items.push({
        id: product.id,
        variantId: product.variantId,
        title: product.title,
        variantTitle: product.variantTitle,
        image: product.image,
        quantity: parseInt(product.quantity),
        url: product.url,
        price: product.price,
        properties: product.properties || {}
      });
    }

    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.dispatchUpdate();
    this.showNotification('Item added to quote');
  }

  removeItem(index) {
    const items = this.getItems();
    items.splice(index, 1);
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.dispatchUpdate();
  }

  updateItemQuantity(index, quantity) {
    const items = this.getItems();
    if (quantity < 1) {
      this.removeItem(index);
      return;
    }
    items[index].quantity = parseInt(quantity);
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.dispatchUpdate();
  }

  dispatchUpdate() {
    window.dispatchEvent(new CustomEvent(this.events.UPDATED));
  }

  updateCount() {
    const items = this.getItems();
    const count = items.reduce((sum, item) => sum + item.quantity, 0);
    const countElements = document.querySelectorAll('.quote-count-bubble');

    countElements.forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });
  }

  showNotification(message) {
    // Check if we can use the theme's notification system
    const notificationContainer = document.querySelector('.product-info__add-button');
    if (notificationContainer) {
      // Create a temporary success message
      const msg = document.createElement('div');
      msg.textContent = message;
      msg.style.cssText = 'position: absolute; background: #000; color: #fff; padding: 10px; border-radius: 4px; z-index: 100; margin-top: -50px;';
      notificationContainer.appendChild(msg);
      setTimeout(() => msg.remove(), 3000);
    } else {
      alert(message);
    }
  }

  clear() {
    localStorage.removeItem(this.storageKey);
    this.dispatchUpdate();
  }

  async transferToCart() {
    const items = this.getItems();

    await fetch('/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items.map((item) => {
          return {
            id: item.variantId,
            quantity: item.quantity
          }
        })
      })
    }).then((response) => {
      if (response.status == 200) {
        this.showNotification("Items added to cart.")
      }
    }).catch((error) => {
      this.showNotification(error.message)
    });

    this.clear();
  }
}

window.quoteCart = new QuoteCart();
